import React from "react";
import { TripSite } from "../types";
import TripEmptyState from "../emptyState";

const TripSites = ({ site }: { site?: TripSite }) => {
  const details = site?.siteDetails || [];
  const hasData = details.length > 0;

  return (
    <section className="trip-section">
      <div className="trip-section-header">
        <h2 className="trip-section-title">Dive sites</h2>
        {site?.completionLevel != null ? (
          <span className="trip-completion">
            {site.completionLevel}% complete
          </span>
        ) : null}
      </div>

      {!hasData ? (
        <TripEmptyState message="No dive sites available" />
      ) : (
        <div className="trip-sites-list">
          {details.map((detail, index) => {
            const siteNames = (detail.site || [])
              .map((s) => s.name)
              .filter(Boolean)
              .join(", ");
            const location = [detail.city, detail.country]
              .filter(Boolean)
              .join(", ");

            return (
              <div
                key={`${detail.city || "site"}-${index}`}
                className="trip-site-card"
              >
                {siteNames ? (
                  <h3 className="trip-site-name">{siteNames}</h3>
                ) : null}
                {location ? (
                  <p className="trip-site-location">{location}</p>
                ) : null}
                {detail.diveCenterName ? (
                  <p className="trip-site-center">{detail.diveCenterName}</p>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default TripSites;
